var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xiuxian-activity",on:{"click":_vm.goDetail}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.item.img),expression:"item.img"}],staticClass:"photo",attrs:{"alt":"activity-photo"}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.title))]),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.item.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }